export default "__VITE_ASSET__FDEbO7Y7__"